import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["el-select-dropdown__item", {
      'selected': _ctx.itemSelected,
      'is-disabled': _ctx.isDisabled,
      'hover': _ctx.hover}]),
    onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hoverItem && _ctx.hoverItem(...args))),
    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.selectOptionClick && _ctx.selectOptionClick(...args)), ["stop"])),
    style: _normalizeStyle(_ctx.inlineStyle)
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createElementVNode("span", null, _toDisplayString(_ctx.currentLabel), 1)
    ], true)
  ], 38)), [
    [_vShow, _ctx.visible]
  ])
}